import "../sass/layout/navbar/navbar.css";
import { useDispatch, useSelector } from "react-redux";
import { Nav, Navbar } from "react-bootstrap";
import { FiAlignJustify } from "react-icons/fi";
import { useTranslation } from "react-i18next";
import { MdOutlineNotifications } from "react-icons/md";
import UserService from "../services/api/UserService";
import { useNavigate } from "react-router-dom";
import DropdownLocation from "./dropdownLocation/dropdownLocation";
import { useEffect, useState } from "react";
import { usePath } from "../hooks/usePath";
import { Mixpanel } from "../utils/mixpanelIntegration";

const NavbarComponent = () => {
  const { t } = useTranslation();
  let navigate = useNavigate();
  const path = usePath();
  const location = useSelector((state) => state.homeReducer.location?.data);
  const userDetail = useSelector((state) => state.userReducer.userDetail);
  const [miiaEmployee, setMiiaEmployee] = useState(false);
  const savedRetireeId = localStorage.getItem('selectedRetireeId') || '';
  const id = useSelector(
    (state) => state.homeReducer.location?.data
  )?.uniqueNonGuessableId;

  const isRetireesPage = window.location.pathname.includes("/retirees");
  const isPrivacyPoliciesPage = window.location.pathname.includes("/privacy-policies");

  useEffect(() => {
    //CHECK
    sessionStorage.setItem("id", window.location.pathname);
  }, []);

  useEffect(() => {
    if (UserService.isLoggedIn()) {
      setMiiaEmployee(!!userDetail?.portal_user_role?.miia_employee);
    }
  }, [userDetail]);

  const onClickContactMiia = () => {
    if (path === "retirees") {
      navigate({
        pathname: `/${path}/contactMIIAteam`,
      });
    } else if (!UserService.isLoggedIn()) {
      window.open("https://www.emiia.org/contact", "_blank");
    } else {
      navigate({
        pathname: `/${path}/contactMIIAteam`,
      });
    }
  };

  return (
    <Navbar className="no-border" expand="lg">
      {UserService.isLoggedIn() && (
        <MdOutlineNotifications className="icon-notif-tablet" />
      )}
      <Navbar.Toggle
        aria-controls="responsive-navbar-nav"
        className="toggler-custom"
        children={<FiAlignJustify className="icon-menu" />}
      />
      <Navbar.Collapse
        className="navbar-yell"
        id="responsive-navbar-nav justify-content-end"
      >
        {/* Left side */}
        <Nav className="me-auto ms-3">
          {(window.location.pathname !== "/" &&
            (window.location.pathname !== "/retirees" || savedRetireeId.length > 0) &&
            !isPrivacyPoliciesPage) && ( // Do not show in the retiree selector or privacy policies page
              <Nav.Item bsPrefix="navbar-label chelmsford-desktop">
                <span
                  style={
                    miiaEmployee
                      ? {
                        marginRight: "2.5rem",
                      }
                      : undefined
                  }
                >
                  {t("homepage.youarein")}
                </span>
                {miiaEmployee ? (
                  <DropdownLocation />
                ) : (
                  <span className="btn-town icon-dropdown">
                    {location?.title ?? t("homepage.cityNotFound")}
                  </span>
                )}
              </Nav.Item>
            )}

        </Nav>
        {/* Right side */}
        <Nav className="ms-auto">

          {!isRetireesPage && (<Nav.Item bsPrefix="navbar-label">
            <Nav.Link
              href="https://www.emiia.org/about"
              target="_blank"
              bsPrefix="navbar-a"
              onClick={() => { Mixpanel.track("Navbar.About", { locationName: location?.name }) }}
            >
              {t("homepage.about")}
            </Nav.Link>
          </Nav.Item>)}
          <Nav.Item bsPrefix="navbar-label" onClick={onClickContactMiia}>
            <Nav.Link
              onClick={() => { Mixpanel.track("Navbar.Contact", { locationName: location?.name }) }}
              href=""
              target="_self"
              bsPrefix="navbar-a"
            >
              {path === "retirees" ? t("homepage.contactmiia") : t("homepage.contactsimple")}
            </Nav.Link>
          </Nav.Item>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
};

export default NavbarComponent;
